import React, { useState } from "react";
import { Form, Field } from "react-final-form";

// import { CONFIRM_ALERT } from '../../../../../constants';
import PasswordStrenth from "../../../../../components/UI/PasswordStrength/PasswordStrength";

const Credentials = (props) => {
  const [newPasswordIsVisible, setNewPasswordIsVisible] = useState(false);
  const [oldPasswordIsVisible, setOldPasswordIsVisible] = useState(false);
  const [confirmPasswordIsVisible, setConfirmPasswordIsVisible] =
    useState(false);

  // <Form onSubmit={props.testflight} initialValues={{email: props.userEmail, code: props.companyCode}} render={({handleSubmit, submitting, pristine, values}) => (
  //     <form onSubmit={handleSubmit} autoComplete="false">
  //         <div className="form-group form-material floating" data-plugin="formMaterial">
  //             <div className="input-group">
  //                 <div className="input-group-prepend">
  //                     <span className="input-group-text"><i className="icon ti-email" aria-hidden="true"></i></span>
  //                 </div>
  //                 <div className="form-control-wrap">
  //                     <Field type="email" name="email" className="form-control empty" id="email" component="input" required />
  //                     <label className="floating-label" htmlFor="email">Your email</label>
  //                 </div>
  //             </div>
  //         </div>
  //         <div className="form-group form-material floating" data-plugin="formMaterial">
  //             <div className="input-group">
  //                 <div className="input-group-prepend">
  //                     <span className="input-group-text"><i className="icon ti-lock" aria-hidden="true"></i></span>
  //                 </div>
  //                 <div className="form-control-wrap">
  //                     <Field type="text" name="code" className="form-control empty" component="input" required />
  //                     <label className="floating-label">Code</label>
  //                 </div>
  //             </div>
  //         </div>
  //         <div className="form-group">
  //             <button type="submit" className="btn btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic" disabled={submitting || pristine} style={{width: '49%'}}>
  //                 <span><i className="icon ti-check" aria-hidden="true"></i>&nbsp;Submit</span>
  //             </button>
  //             &nbsp;
  //             <button type="button" className="btn btn-animate btn-animate-vertical btn-danger btn-sm waves-effect waves-classic" disabled={submitting} onClick={CONFIRM_ALERT.bind(this, 'Cancel', 'Cancel password reset?', () => window.location.href = "/")} style={{width: '49%'}}>
  //                 <span><i className="icon ti-close" aria-hidden="true"></i>&nbsp;Cancel</span>
  //             </button>
  //         </div>
  //         {props.passwordChanged && (
  //             <a className="float-center" href='/'>
  //                 <i className="icon fa-sign-in" aria-hidden="true"></i>&nbsp;Sign in
  //             </a>
  //         )}
  //         {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
  //     </form>
  // )}/>
  return (
    <Form
      onSubmit={props.changeExpiredPassword}
      render={({ handleSubmit, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} autoComplete="false">
          {/* <div className="form-group form-material floating" data-plugin="formMaterial">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="icon fa-key" aria-hidden="true"></i></span>
                        </div>
                        <div className="form-control-wrap">
                            <Field type="text" name="username" className="form-control empty" id="username" component="input" required />
                            <label className="floating-label" htmlFor="otp"></label>
                        </div>
                    </div>
                </div>
                <div className="form-group form-material floating" data-plugin="formMaterial">
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text"><i className="icon fa-key" aria-hidden="true"></i></span>
                        </div>
                        <div className="form-control-wrap">
                            <Field type="text" name="companyCode" className="form-control empty" id="companyCode" component="input" required />
                            <label className="floating-label" htmlFor="otp">Company Code</label>
                        </div>
                    </div>
                </div> */}
          <div
            className="form-group form-material floating"
            data-plugin="formMaterial"
          >
            <div className="input-group">
              <div
                className="input-group-prepend"
                onClick={() => setOldPasswordIsVisible(!oldPasswordIsVisible)}
                style={{ cursor: "pointer" }}
              >
                <span className="input-group-text">
                  <i
                    className={
                      !oldPasswordIsVisible
                        ? "icon fa-eye-slash"
                        : "icon fa-eye"
                    }
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
              <div className="form-control-wrap">
                <PasswordStrenth
                  userPasswordChangeHandler={(password, isValid) =>
                    props.userOldPasswordInputChangeHandler(password, isValid)
                  }
                  inputProps={{
                    type: oldPasswordIsVisible ? "text" : "password",
                    placeholder: "Old Password",
                    autoComplete: "off",
                  }}
                  style={{ position: "absolute" }}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group form-material floating"
            data-plugin="formMaterial"
          >
            <div className="input-group">
              <div
                className="input-group-prepend"
                onClick={() => setNewPasswordIsVisible(!newPasswordIsVisible)}
                style={{ cursor: "pointer" }}
              >
                <span className="input-group-text">
                  <i
                    className={
                      !newPasswordIsVisible
                        ? "icon fa-eye-slash"
                        : "icon fa-eye"
                    }
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
              <div className="form-control-wrap">
                <PasswordStrenth
                  userPasswordChangeHandler={(password, isValid) =>
                    props.userNewPasswordInputChangeHandler(password, isValid)
                  }
                  inputProps={{
                    type: newPasswordIsVisible ? "text" : "password",
                    placeholder: "New Password",
                  }}
                  style={{ position: "absolute" }}
                />
              </div>
            </div>
          </div>
          <div
            className="form-group form-material floating"
            data-plugin="formMaterial"
          >
            <div className="input-group" disabled={!props.newPassword}>
              <div
                className="input-group-prepend"
                onClick={() =>
                  setConfirmPasswordIsVisible(!confirmPasswordIsVisible)
                }
                style={{ cursor: "pointer" }}
              >
                <span className="input-group-text">
                  <i
                    className={
                      !confirmPasswordIsVisible
                        ? "icon fa-eye-slash"
                        : "icon fa-eye"
                    }
                    aria-hidden="true"
                  ></i>
                </span>
              </div>
              <div className="form-control-wrap">
                <PasswordStrenth
                  userPasswordChangeHandler={(password, isValid) =>
                    props.userConfirmPasswordInputChangeHandler(
                      password,
                      isValid
                    )
                  }
                  inputProps={{
                    type: confirmPasswordIsVisible ? "text" : "password",
                    placeholder: "Confirm Password",
                  }}
                  style={{ position: "absolute" }}
                />
              </div>
              <span
                style={{
                  display: props.error !== null ? "block" : "none",
                  color: "red",
                }}
              >
                {props.error}
              </span>
            </div>
          </div>
          <div className="form-group clearfix">
            <button
              type="submit"
              className="btn btn-block btn-raised btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic"
              disabled={
                submitting ||
                !props.newPassword ||
                !props.confirmPassword ||
                !props.oldPassword
              }
            >
              <span>
                <i className="icon ti-thumb-up" aria-hidden="true"></i>
                &nbsp;Reset password
              </span>
            </button>
          </div>
          {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
        </form>
      )}
    />
  );
};

export default Credentials;
